export default __webpack_public_path__ + "static/media/trending_img.e6eefd91.png";